import { render, staticRenderFns } from "./VerEmisionPublica.vue?vue&type=template&id=2f66e390&scoped=true"
import script from "./VerEmisionPublica.vue?vue&type=script&lang=js"
export * from "./VerEmisionPublica.vue?vue&type=script&lang=js"
import style0 from "./VerEmisionPublica.vue?vue&type=style&index=0&id=2f66e390&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f66e390",
  null
  
)

export default component.exports